
const EmbedLogo = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-4 2xl:w-5 h-auto"
      fill="none"
      viewBox="0 0 15 15"
    >
      <path
        fill="#1C2B33"
        d="M7.188 8.438h3.125v-1.25H7.187zm-.938.937V6.25h5v3.125zM2.5 12.5q-.516 0-.883-.367a1.2 1.2 0 0 1-.367-.883v-7.5q0-.516.367-.883.368-.367.883-.367h10q.516 0 .883.367.367.368.367.883v7.5q0 .516-.367.883a1.2 1.2 0 0 1-.883.367zm0-1.25h10V5h-10z"
      ></path>
    </svg>
  );
};

export default EmbedLogo;